import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function ToolHeader({ title, subtitle, back = '/staff-app/tools', right = null }) {
  const navigate = useNavigate();
  return (
    <div className="flex items-center gap-2 px-4 py-2.5 border-b border-border bg-background">
      <button onClick={() => navigate(back)} aria-label="Back" data-testid="staff-app-tool-back" className="p-1 -ml-1">
        <ArrowLeft className="w-5 h-5" />
      </button>
      <div className="min-w-0 flex-1">
        <p className="text-sm font-bold truncate" data-testid="staff-app-tool-title">{title}</p>
        {subtitle && <p className="text-[11px] text-muted-foreground truncate">{subtitle}</p>}
      </div>
      {right}
    </div>
  );
}

export function NoAccess({ text = "You don't have access to this tool. Ask your pharmacy admin." }) {
  return <p className="px-4 py-16 text-center text-sm text-muted-foreground" data-testid="staff-app-tool-no-access">{text}</p>;
}

export function Spinner() {
  return <div className="flex justify-center py-16"><span className="w-6 h-6 rounded-full border-2 border-muted-foreground/30 border-t-primary animate-spin" /></div>;
}
